import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { WASTE_WOOD_GROUP_TYPE, WASTE_WOOD_TYPE, WOOD_GRADE_CHOICES } from "../../constance/dataTypes";
import * as _ from "lodash";
import { Form, Input, Select , InputNumber} from "antd";
import { defaultPostBakingWasteWoodInputDetail } from "../../constance/dataTypes";


export default function CountWasteWoodForm(props) {
  const {
    style,
    form
  } = props;

  const { t } = useTranslation();
  const [wasteWoodTypeOptions, setWasteWoodTypeOptions] = React.useState([]);
  const waste_wood_group = Form.useWatch('waste_wood_group', form)

  const wasteWoodGroupOptions = Object.entries(WASTE_WOOD_GROUP_TYPE).map(([_, value]) => ({
    key: value, value, label: t(`post_baking_waste_wood_input.waste_wood_groups.${value}`)
  }))

  React.useEffect(() => {
    if (waste_wood_group) {
      setWasteWoodTypeOptions(
        Object.entries(WASTE_WOOD_TYPE[waste_wood_group] || {}).map(([_, value]) => ({
          key: value, value, label: t(`post_baking_waste_wood_input.waste_wood_types.${value}`)
        }))
      )
    }
  }, [waste_wood_group])

  return (
    <Form
      style={{ width: 'fit-content', margin: 'auto', textAlign: 'left', ...style }}
      form={form}
      initialValues={defaultPostBakingWasteWoodInputDetail}
    >
      <Form.Item name={'transaction'} hidden />
      <Form.Item
        name='grade'
        label={t('wood_imports.grade')}
        rules={[{ required: true, message: t('error_messages.validation.required') }]}>
        <Select options={WOOD_GRADE_CHOICES} />
      </Form.Item>
      <Form.Item
        name='wood_code_dimension'
        label={t('wood_size')}
        rules={[
          { required: true, message: t('error_messages.validation.required') },
          { len: 10, message: t('error_messages.validation.length') }
        ]}>
        <Input />
      </Form.Item>
      <Form.Item
        label={t('barcodes.amount')}
        name='amount'
        rules={[{ required: true, message: null },
        {
          validator: (_, value) => {
            if (!value) {
              return Promise.reject(t('error_messages.validation.required'))
            }
            if (value <= 0) {
              return Promise.reject(`${t('error_messages.validation.more_than')} 0`);
            }
            return Promise.resolve();
          },
        },
        ]}>
        <InputNumber style={{width: '100%'}}/>
      </Form.Item>
      <Form.Item
        label={t('post_baking_waste_wood_input.waste_wood_group')}
        name='waste_wood_group'
        rules={[{ required: true, message: t('error_messages.validation.required') }]}>
        <Select options={wasteWoodGroupOptions}
          onChange={() => { form.setFieldsValue({ waste_wood_type: null }); }} />
      </Form.Item>
      <Form.Item
        name='waste_wood_type'
        label={t('post_baking_waste_wood_input.waste_wood_type')}
        rules={[{ required: true, message: t('error_messages.validation.required') }]}
      >
        <Select options={wasteWoodTypeOptions} />
      </Form.Item>
    </Form>
  )
}

CountWasteWoodForm.propTypes = {
  style: PropTypes.object,
  form: PropTypes.object,
}

CountWasteWoodForm.defaultProps = {
  style: {},
  form: {},
}